import {Component, Input, OnInit} from '@angular/core';
import {TablePulseAbstractComponent} from '../../table-pulse-abstract/table-pulse-abstract.component';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
@Component({
  selector: 'app-table-pulse-name',
  templateUrl: './table-pulse-name.component.html',
  styleUrls: ['../../../../views/new-table/new-table.component.css']
})
export class TablePulseNameComponent extends TablePulseAbstractComponent implements OnInit {
  currentUser: any; // 存放当前用户信息
  permissionDefinition: any;
  constructor(
    private taskHttpService: TaskService,
    private nzMessageService: NzMessageService
  ) {
    super(nzMessageService, taskHttpService);
  }
  ngOnInit(): void {
  }
}
